import { memo } from "react";
import { Table } from "react-bootstrap";
import trashIcon from "../assets/images/trash-icon.svg";


const CollaboratorsEmail = memo((props) => {

    const { showEmails, removeEmail, setShowEmails, isEditDet } = props

    const handlePermissions = (index, key, value) => {

        let mails = [...showEmails]

        mails[index][key] = value

        setShowEmails(mails)


    }


    return (
        <>
            <Table bordered hover responsive className="custom-table-border1 mt-1" >
                <thead>
                    <tr  >
                        <th style={{ textAlign: 'left', padding: '4px' }} className="job_size font-size-h4 font-weight-400 ">Email Id  </th>
                        <th style={{ textAlign: 'left', padding: '4px' }} className="job_size font-size-h4 font-weight-400">Daily Mails</th>
                        <th style={{ textAlign: 'left', padding: '4px' }} className="job_size font-size-h4 font-weight-400">Edit</th>
                        <th style={{ textAlign: 'left', padding: '4px' }} className="job_size font-size-h4 font-weight-400">View</th>
                        <th style={{ textAlign: 'left', padding: '4px' }} className="job_size font-size-h4 font-weight-400">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        showEmails.map((email, index) => {
                            return <tr>
                                <td style={{ textAlign: "left", padding: '4px' }}>
                                    <div className="font-size-h4 text-slate-dark">
                                        {email?.email}
                                    </div>
                                </td>
                                <td className="text-left" style={{ width: '110px', padding: '4px' }}>
                                    <input type="checkbox"
                                        checked={email?.isDailyReportEnabled}
                                        disabled={isEditDet}
                                        onChange={(e) => handlePermissions(index, 'isDailyReportEnabled', e.target.checked)}
                                    />

                                </td>
                                <td className="text-left" style={{ width: '110px', padding: '4px' }}>
                                    <input type="checkbox"
                                        checked={email?.isEditEnabled}
                                        disabled={isEditDet}
                                        onChange={(e) => {
                                            handlePermissions(index, 'isEditEnabled', e.target.checked)
                                            if (e.target.checked) {
                                                handlePermissions(index, 'isViewEnabled', true)
                                            }
                                        }}
                                    />

                                </td>
                                <td className="text-left" style={{ width: '110px', padding: '4px' }}>
                                    <input type="checkbox"
                                        checked={email?.isViewEnabled}
                                        disabled={isEditDet}
                                        onChange={(e) => {
                                            handlePermissions(index, 'isViewEnabled', e.target.checked)
                                            if (!e.target.checked) {
                                                handlePermissions(index, 'isEditEnabled', false)
                                            }
                                        }}
                                    />

                                </td>
                                <td className="text-left" style={{ width: '110px', padding: '4px' }}>
                                    <img src={trashIcon} style={{ height: '15px', width: '15px', cursor: 'pointer', marginTop: '-5px' }}
                                        onClick={() => !isEditDet && removeEmail(index)}
                                    />

                                </td>
                            </tr>
                        })
                    }


                </tbody>
            </Table>
        </>
    )

})

export default CollaboratorsEmail